import React from "react";
import { Box, Typography } from "@mui/material";
import { Alert } from "@components/Alert/Alert";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.add`;

/** No arithmetic (HLD 5.3): the figure is displayed as the server computed it, never derived or floored. */
const TotalQuantityRemained: React.FC<{ value: number | null | undefined }> = ({ value }) => {
  const { t } = useTranslation();
  if (value == null) {
    return null;
  }
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="body2" color="text.secondary" fontWeight={500}>
        {t(`${L}.total-quantity-remained`)}
      </Typography>
      <Typography variant="subtitle1" fontWeight={700} data-testid="total-quantity-remained">
        {String(value)}
      </Typography>
    </Box>
  );
};

export const RemainedWarning: React.FC<{ value: number | null | undefined }> = ({ value }) => {
  const { t } = useTranslation();
  if (value == null || value === 0) {
    return null;
  }
  const shown = String(value);
  return (
    <div role="status" aria-live="polite">
      <Alert type="warning">
        {value > 0
          ? t(`${L}.remained.under`, { quantity: shown })
          : t(`${L}.remained.over`, { quantity: shown.replace(/^-/, "") })}
      </Alert>
    </div>
  );
};

export default TotalQuantityRemained;
